"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.File = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
require("./index.css");
var _default = exports["default"] = function _default(_ref) {
  var children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, _react["default"].Children.count(children) > 0 ? children : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    src: t('placeholder-file.png'),
    text: t('contact.detail.file.empty')
  }));
};
var File = exports.File = function File(_ref2) {
  var icon = _ref2.icon,
    name = _ref2.name,
    date = _ref2.date,
    type = _ref2.type,
    onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4 cursor-pointer hover:bg-secondary",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-left h-10 pr-4 floating-align-middle"
  }, icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between text-xs text-light"
  }, /*#__PURE__*/_react["default"].createElement("div", null, type), /*#__PURE__*/_react["default"].createElement("div", null, date)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-dark font-bold truncate pr-4 flex-shrink"
  }, name)));
};
//# sourceMappingURL=FilesView.js.map